import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

const ZoneStatusUpdateModal = ({ isOpen, onClose, zone, onStatusUpdate }) => {
  const [selectedStatus, setSelectedStatus] = useState('active');
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (zone && zone.status) {
      setSelectedStatus(zone.status.toLowerCase());
    } else {
      setSelectedStatus('active');
    }
  }, [zone]);

  if (!isOpen || !zone) return null;

  const handleStatusUpdate = async () => {
    if (!zone || !zone.zone_id) return;
    
    setIsUpdating(true);
    try {
      const token = localStorage.getItem('authToken');
      const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
      
      // Use the exact same data structure as EditZoneModal
      const updateData = {
        zone_name: zone.zone_name,
        mmda_id: zone.mmda_id,
        description: zone.description,
        status: selectedStatus,
        zone_id: zone.zone_id
      };
      
      await axios.put(
        `${API_BASE_URL}/zones/${zone.zone_id}`,
        updateData,
        config
      );
      
      onStatusUpdate(zone.zone_id, selectedStatus);
      onClose();
    } catch (error) {
      console.error('Error updating status:', error);
      alert('Failed to update status. Please try again.');
    } finally {setIsUpdating(false);};
  }
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div 
        style={{
          backgroundColor: 'white',
          padding: '24px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          minWidth: '300px',
          maxWidth: '400px'
        }}
        onClick={(e) => e.stopPropagation()}
      >        
        <div style={{ marginBottom: '20px' }}>

          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold',color: '#1976d2' }}>
            Select New Status:
          </label>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            style={{
              width: '100%',
              padding: '8px 12px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              fontSize: '16px'
            }}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>

          <button
            onClick={handleStatusUpdate}
            style={{
              padding: '8px 16px',
              borderRadius: '4px',
              border: 'none',
              backgroundColor: '#1976d2',
              color: 'white',
              cursor: 'pointer'
            }}
            disabled={isUpdating}
          >
            {isUpdating ? 'Updating...' : 'Update Status'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ZoneStatusUpdateModal;
